import { AppBar, Toolbar, Grid, Card } from "@mui/material";
import { BrowserRouter as Router, Link } from "react-router-dom";
import logo from "../images/logo.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import menu from "../images/icon-hamburger.svg";
import close from "../images/icon-close.svg";
import { useState } from "react";

const NavBar = () => {
  const [show, setShow] = useState(true);
  const handleClick = () => {
    setShow(show ? false : true);
    console.log(show);
  };
  const headerStyle = {
    background: "hsl(0, 0%, 100%)",
    color: "hsl(233, 8%, 62%)",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    padding: "0 0 0 9rem",
  };
  const linkStyle = {
    margin: "0 15rem 0 18rem",
  };
  const linkQuery =
    useMediaQuery("(min-width:1350px)") | useMediaQuery("(min-width:1500px)");

  const Icon = () => {
    if (show) {
      return (
        <AppBar
          position="fixed"
          elevation={0}
          style={{ ...headerStyle, padding: "0 1.5rem" }}
        >
          <img src={logo} className="logo" />{" "}
          <img src={menu} onClick={handleClick} className="icon" />
        </AppBar>
      );
    } else {
      return (
        <div className="menu">
          <AppBar elevation={0} style={{ ...headerStyle, padding: "0 1.5rem" }}>
            <img src={logo} className="logo" />{" "}
            <img src={close} onClick={handleClick} className="icon" />
          </AppBar>
          <Router>
            <Card className="list">
              {" "}
              <Link className="link">Home</Link>
              <Link className="link">About</Link>
              <Link className="link">Contact</Link>
              <Link className="link">Blog</Link>
              <Link className="link">Careers</Link>
            </Card>
          </Router>
        </div>
      );
    }
  };

  const matches = useMediaQuery("(min-width:480px)");
  if (matches) {
    return (
      <div className="header">
        <Router>
          <AppBar position="fixed" elevation={0} style={headerStyle}>
            <Grid item xs={2}>
              <img src={logo} className="logo"></img>
            </Grid>
            <Grid
              item
              xs={3}
              sm={4}
              md={6}
              lg={8}
              style={linkQuery ? { ...linkStyle } : { margin: "0 auto" }}
            >
              <Toolbar>
                {" "}
                <Link className="link">Home</Link>
                <Link className="link">About</Link>
                <Link className="link">Contact</Link>
                <Link className="link">Blog</Link>
                <Link className="link">Careers</Link>
              </Toolbar>
            </Grid>
            <Grid item xs={2}>
              <button color="inherit" style={{ marginTop: ".6rem" }}>
                Request Invite
              </button>
            </Grid>
            <Grid container></Grid>
          </AppBar>
        </Router>
      </div>
    );
  } else {
    return (
      <div>
        <Icon />
      </div>
    );
  }
};
export default NavBar;
